import {
  Box,
  Container,
  Typography,
  Grid,
  Button,
  Stack,
  Divider,
} from "@mui/material";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import FlashOnIcon from "@mui/icons-material/FlashOn";
import PaletteIcon from "@mui/icons-material/Palette";
import CloudIcon from "@mui/icons-material/Cloud";
import VerifiedIcon from "@mui/icons-material/Verified";
import DevicesIcon from "@mui/icons-material/Devices";

export default function MobileDevelopment() {
  return (
    <Box sx={{ backgroundColor: "#020617", color: "#e5e7eb" }}>
      {/* ================= HERO ================= */}
      <Box sx={{ py: 12 }}>
        <Container>
          <Typography
            variant="h3"
            align="center"
            fontWeight={600}
            gutterBottom
          >
            Mobile App Development
          </Typography>

          <Typography
            align="center"
            sx={{ maxWidth: 900, mx: "auto", opacity: 0.9 }}
          >
            We build scalable, high-performance mobile applications that deliver
            seamless user experiences across platforms while meeting enterprise
            security and reliability standards.
          </Typography>

          {/* Tabs */}
          <Stack
            direction="row"
            spacing={2}
            justifyContent="center"
            mt={6}
            flexWrap="wrap"
          >
            <Button sx={tab}>Cross-Platform Apps</Button>
            <Button sx={tab}>Native Performance</Button>
            <Button sx={tab}>UI / UX Design</Button>
            <Button sx={tab}>Cloud Integration</Button>
          </Stack>

          <Divider sx={{ mt: 3, borderColor: "#1e293b" }} />
        </Container>
      </Box>

      {/* ================= CORE SECTION ================= */}
      <Container sx={{ py: 10 }}>
        <Grid container spacing={6} alignItems="center">
          <Grid item xs={12} md={6}>
            <Typography variant="h4" gutterBottom>
              Enterprise-Grade Mobile Solutions
            </Typography>

            <Typography sx={{ mb: 3, opacity: 0.9 }}>
              Our mobile applications are engineered for performance, security,
              and scalability. We focus on building robust solutions that align
              with business goals and user expectations.
            </Typography>

            <Typography sx={{ opacity: 0.85 }}>
              From customer-facing apps to internal enterprise tools, we ensure
              reliability, maintainability, and long-term growth.
            </Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box
              component="img"
              src="https://images.unsplash.com/photo-1511707171634-5f897ff02aa9"
              alt="Mobile App Development"
              sx={{
                width: "100%",
                borderRadius: 3,
                boxShadow: "0 20px 40px rgba(0,0,0,0.45)",
              }}
            />
          </Grid>
        </Grid>
      </Container>

      {/* ================= WHY CHOOSE US ================= */}
      <Box sx={{ backgroundColor: "#020617", py: 12 }}>
        <Container>
          <Typography
            variant="h4"
            align="center"
            gutterBottom
            fontWeight={600}
          >
            Why Choose NerdsHub for Mobile Development?
          </Typography>

          <Grid container spacing={8} mt={4}>
            {/* Left Image */}
            <Grid item xs={12} md={6}>
              <Box
                component="img"
                src="https://images.unsplash.com/photo-1558655146-d09347e92766"
                alt="Mobile UX"
                sx={{ width: "100%", borderRadius: 3 }}
              />
            </Grid>

            {/* Right Content */}
            <Grid item xs={12} md={6}>
              <Feature
                icon={<PhoneIphoneIcon />}
                title="Cross-Platform Excellence"
                desc="Single codebase solutions using modern frameworks to deliver consistent experiences across Android and iOS."
              />

              <Feature
                icon={<FlashOnIcon />}
                title="High Performance"
                desc="Optimized rendering, smooth animations, and fast load times for superior user engagement."
              />

              <Feature
                icon={<PaletteIcon />}
                title="User-Centric Design"
                desc="Intuitive, modern UI/UX focused on usability, accessibility, and brand consistency."
              />
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* ================= CLOUD & DELIVERY ================= */}
      <Container sx={{ py: 12 }}>
        <Grid container spacing={8}>
          <Grid item xs={12} md={6}>
            <Box
              component="img"
              src="https://images.unsplash.com/photo-1498050108023-c5249f4df085"
              alt="Mobile Cloud Integration"
              sx={{ width: "100%", borderRadius: 3 }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <Feature
              icon={<CloudIcon />}
              title="Cloud-Ready Architecture"
              desc="Seamless integration with cloud services, APIs, and backend systems for scalability and reliability."
            />

            <Feature
              icon={<DevicesIcon />}
              title="Device Compatibility"
              desc="Tested across multiple devices, screen sizes, and OS versions to ensure consistent behavior."
            />

            <Feature
              icon={<VerifiedIcon />}
              title="Secure & Reliable Delivery"
              desc="Built with security best practices, CI/CD pipelines, and enterprise-grade quality assurance."
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

/* ================= REUSABLE FEATURE ================= */

function Feature({ icon, title, desc }) {
  return (
    <Box sx={{ display: "flex", mb: 5 }}>
      <Box
        sx={{
          width: 44,
          height: 44,
          borderRadius: "50%",
          backgroundColor: "#ec4899",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mr: 3,
          color: "#fff",
        }}
      >
        {icon}
      </Box>

      <Box>
        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>
        <Typography sx={{ opacity: 0.85 }}>{desc}</Typography>
      </Box>
    </Box>
  );
}

/* ================= STYLES ================= */

const tab = {
  color: "#9ca3af",
  textTransform: "none",
};
